import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import ListIcon from '@mui/icons-material/List';
import StarIcon from '@mui/icons-material/Star';
import type { SvgIconProps } from '@mui/material/SvgIcon';
import type { ComponentType } from 'react';

export const NEOBET_OPEN_BETSLIP_EVENT = 'neobetOpenBetslip';
// Header rail slot and desktop drawer consume these together; keep them paired
// so collapse animation does not desync between header and sidebar.
export const NEOBET_DESKTOP_DRAWER_WIDTH = 232;
export const NEOBET_COMPACT_DRAWER_WIDTH = 64;
export const NEOBET_FEATURED_TAB_PATH = '/sports';
export const NEOBET_PREMATCH_TAB_PATH = '/sports/1/matches';
export const NEOBET_IN_PLAY_TAB_PATH = '/in-play';
export const NEOBET_MY_BETS_TAB_PATH = '/my-bets';

export type UpcomingMatchesTab = {
  labelKey: string;
  value: string;
  icon: ComponentType<SvgIconProps>;
};

export const NEOBET_UPCOMING_MATCHES_TABS: UpcomingMatchesTab[] = [
  { labelKey: 'schedule', value: 'schedule', icon: CalendarMonthIcon },
  { labelKey: 'allMatches', value: 'all-matches', icon: ListIcon },
  { labelKey: 'topLeagues', value: 'top-leagues', icon: StarIcon },
];

export const NEOBET_UPCOMING_MATCHES_INTERVALS = ['today', '3', '6', '12', '24'] as const;
export const NEOBET_UPCOMING_MATCHES_DEFAULT_INTERVAL = '3' as const;
